import { Moment, tz } from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'

import { shortDateWithDayOfWeek, longDateWithDayOfWeekAndTime } from 'helpers/formatters'

import { color } from 'styles/colors'
import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'
import Tooltip from 'components/Tooltip'

type Props = {
  eventOccurredAt: number
  timeZone: string
  withoutSeconds?: boolean
  showDayRthCallback?: (day: Moment) => void
}

const AlertEventTime = ({ eventOccurredAt, timeZone, withoutSeconds = false, showDayRthCallback }: Props) => {
  const { showUpgrade } = usePremiumFeaturesContext()

  const timeWithTimeZone = tz(Number(eventOccurredAt) * 1000, timeZone)

  const presentDate = tz(timeZone)
  const isOccurredWithInRange = presentDate.diff(timeWithTimeZone, 'days') <= 30
  const isUpgradeRequired = !isOccurredWithInRange && showUpgrade('extended_rthg')

  const onDayRthClickCallback = () => {
    if (!isUpgradeRequired) {
      showDayRthCallback?.(timeWithTimeZone)
    }
  }

  const tooltipTitle = isUpgradeRequired
    ? 'Alert triggered more than 30 days ago. Upgrade to Diagnostics Premium to access historical runtime graph data.'
    : ''

  const timeContent = (
    <S.AlertEventTime enabled={!isUpgradeRequired} isUpgradeRequired={isUpgradeRequired} onClick={onDayRthClickCallback}>
      {withoutSeconds ? shortDateWithDayOfWeek(timeWithTimeZone) : longDateWithDayOfWeekAndTime(timeWithTimeZone)}

      {<S.DisplayDayRthIcon className="icon-display-day-rth" aria-label="display day rth" />}
    </S.AlertEventTime>
  )

  return isUpgradeRequired ? (
    <Tooltip title={tooltipTitle}>
      {timeContent}
    </Tooltip>
  ) : (
    timeContent
  )
}

export default AlertEventTime

const S = {
  AlertEventTime: styled(KeyboardAccessible).withConfig({
    shouldForwardProp: (prop) => !['isUpgradeRequired'].includes(prop)
  })<{ isUpgradeRequired: boolean }>`
    display: inline-block;
    color: ${color('primaryText')};

    &:hover {
      color: ${({ isUpgradeRequired }) => isUpgradeRequired ? color('primaryText') : color('anchorHover')};
    }
  `,
  DisplayDayRthIcon: styled.i`
    display: inline;
    padding-left: 5px;
  `
}
